<script>
  export default {
    functional: true,

    name: 'cardBodyText',

    render (h, {data, children} ) {
      const staticClass = 'card-body-text';
      data.staticClass = data.staticClass ? `${data.staticClass} ${staticClass}` : staticClass

      return h('section', {
        ...data
      }, children)
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/UiCardBodyText.vue